export { default } from './SliderWithDots'
